<template>
  <div class="">

      <br />
      <v-card>

        <v-card-title primary-title>
          Your site colors are:
        </v-card-title>

        <v-progress-circular v-if="inprogress" indeterminate></v-progress-circular>
        <ThemeDisplay v-else :themeNumber="currentTheme"></ThemeDisplay>

          <br />

          <!-- v-layout>
            <v-flex v-bind:style="{ 'backgroundColor': colors.background, 'color':fontColor }"  >fontColor/background</v-flex>
            <v-flex v-bind:style="{ 'backgroundColor': colors.primary, 'color':fontColor }"  >fontColor/primary</v-flex>
            <v-flex v-bind:style="{ 'backgroundColor': colors.secondary, 'color':fontColor }"  >fontColor/secondary</v-flex>
          </v-layout>

          <v-layout>
            <v-flex v-bind:style="{ 'backgroundColor': colors.background, 'color':fontColor }"  >accent/background</v-flex>
            <v-flex v-bind:style="{ 'backgroundColor': colors.background, 'color':colors.error }"  >error/background</v-flex>
            <v-flex v-bind:style="{ 'backgroundColor': colors.background, 'color':colors.info }"  >info/background</v-flex>
            <v-flex v-bind:style="{ 'backgroundColor': colors.background, 'color':colors.success }"  >success/background</v-flex>
            <v-flex v-bind:style="{ 'backgroundColor': colors.background, 'color':colors.warning }"  >warning/background</v-flex>
          </v-layout -->

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn @click="show = !show" flat color="accent">
            Change Theme
           <v-icon class="ml-1">{{show ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>


         </v-btn>

        </v-card-actions>

        <v-slide-y-transition>
          <v-card-text v-show="show" >
            <div v-if="errMessage != null" class="error--text text-xs-center" >
               {{ errMessage }}
            </div>
            <v-form>
              <ul>
                <li
                  v-for="(item, index) in allThemes"
                  :key="item.title"
                  @click="() => setThemeInDb(index)"
                >
                  <ThemeDisplay :class="index == currentTheme ? 'selected mb-2' : 'mb-2'" :themeNumber="index"></ThemeDisplay>
                </li>
              </ul>

            </v-form>

          </v-card-text>
        </v-slide-y-transition>

      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'
import firebase from 'firebase/app'
import ThemeDisplay from './ThemeDisplay'
import themes from '../../../themes.js'

export default {
  name: 'ThemeSettings',
  components: {
    ThemeDisplay
  },
  computed: {
    ...mapState({
      uid: state => state.admin.uid,
      currentTheme: state => state.admin.public_settings.theme,
      locked: state => state.admin.public_settings.locked

    }),
    allThemes: function () {
      return themes.getAllThemes()
    },
    colors: function () {
      return themes.getTheme(this.currentTheme)
    },
    fontColor: function () {
      return themes.getFontColor(this.currentTheme)
    }
  },
  data () {
    return {
      show: false,
      inprogress: false,
      updateSuccess: false,
      errMessage: null
    }
  },
  methods: {

    setThemeInDb: async function (selectedTheme) {
      this.inprogress = true
      this.errMessage = null
      this.updateSuccess = false

      // Call the server function to generate a unique CSRF token to validate later
      try {
        if (this.locked) {
          throw new Error("Account is locked. You cannot update settings.")
        }

        await firebase.firestore()
          .collection('artists').doc(this.uid).collection('public').doc('settings')
          .set({
            'theme': selectedTheme
          }, {merge: true})

        // Commit the change to the store also
        // this.$store.dispatch('themeInfo/setTheme', selectedTheme)

        this.updateSuccess = true
        console.log('Theme update succeeded: '+selectedTheme)
      } catch (err) {
        this.errMessage = err.message
        console.error('Theme update error:' + err)
      }
      this.inprogress = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.selected {
  border: solid;
  border-color: red;
  border-style:outset;
}

</style>
